export default __webpack_public_path__ + "static/media/ill-fm-kyc.368459da.svg";